import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { FONTS, LANGUAGES } from "@/lib/constants";
import ImageOptions from "./ImageOptions";

function Field({ label, children, hint }) {
  return (
    <div className="space-y-1.5">
      <Label className="text-xs text-slate-600">{label}</Label>
      {children}
      {hint && <p className="text-[11px] text-slate-500">{hint}</p>}
    </div>
  );
}

function FontPick({ value, onChange, empty, testid }) {
  return (
    <Select value={value || "__"} onValueChange={(v) => onChange(v === "__" ? "" : v)}>
      <SelectTrigger data-testid={testid}><SelectValue /></SelectTrigger>
      <SelectContent className="max-h-72"><SelectItem value="__">{empty}</SelectItem>{FONTS.map((f) => <SelectItem key={f} value={f}><span style={{ fontFamily: f }}>{f}</span></SelectItem>)}</SelectContent>
    </Select>
  );
}

export default function ClientStep({ mode, client, setClient, images, setImages, models }) {
  const ai = mode !== "simple";
  const set = (k) => (e) => setClient({ ...client, [k]: e?.target ? e.target.value : e });
  const [fh = "", fb = ""] = (client.fonts || "").split(",").map((x) => x.trim());
  const setFonts = (h, b) => setClient({ ...client, fonts: h || b ? [h, b || h].filter(Boolean).join(", ") : "" });
  return (
    <div className="space-y-6" data-testid="dup-client-step">
      <div className="grid gap-4 sm:grid-cols-2">
        <Field label="Nome del nuovo progetto *"><Input value={client.project_name} onChange={set("project_name")} data-testid="dup-project-name" /></Field>
        <Field label="Nome del nuovo cliente *"><Input value={client.company_name} onChange={set("company_name")} data-testid="dup-company-name" /></Field>
        <Field label={mode === "new_sector" ? "Nuovo settore *" : "Settore"}><Input value={client.sector} onChange={set("sector")} placeholder="Es. palestra boutique" data-testid="dup-sector" /></Field>
        {ai && (
          <Field label="Lingua del sito">
            <Select value={client.language || "__"} onValueChange={(v) => setClient({ ...client, language: v === "__" ? "" : v })}>
              <SelectTrigger data-testid="dup-language"><SelectValue /></SelectTrigger>
              <SelectContent><SelectItem value="__">Come l'originale</SelectItem>{LANGUAGES.map((l) => <SelectItem key={l.value} value={l.value}>{l.label}</SelectItem>)}</SelectContent>
            </Select>
          </Field>
        )}
      </div>
      {ai && (
        <div className="grid gap-4 sm:grid-cols-2">
          <Field label={mode === "new_sector" ? "Descrizione dell'attività *" : "Descrizione dell'attività"}><Textarea rows={3} value={client.description} onChange={set("description")} data-testid="dup-description" /></Field>
          <Field label="Servizi / prodotti principali"><Textarea rows={3} value={client.services} onChange={set("services")} data-testid="dup-services" /></Field>
          <Field label="Pubblico"><Input value={client.audience} onChange={set("audience")} data-testid="dup-audience" /></Field>
          <Field label="Obiettivo del sito"><Input value={client.goal} onChange={set("goal")} data-testid="dup-goal" /></Field>
        </div>
      )}
      <div>
        <p className="text-xs font-semibold uppercase tracking-wider text-slate-500">Contatti del nuovo cliente</p>
        <div className="mt-3 grid gap-4 sm:grid-cols-2">
          <Field label="Email"><Input value={client.email} onChange={set("email")} type="email" data-testid="dup-email" /></Field>
          <Field label="Telefono"><Input value={client.phone} onChange={set("phone")} data-testid="dup-phone" /></Field>
          <Field label="Indirizzo"><Input value={client.address} onChange={set("address")} data-testid="dup-address" /></Field>
          <Field label="Sito web"><Input value={client.website} onChange={set("website")} placeholder="https://" data-testid="dup-website" /></Field>
        </div>
      </div>
      <div>
        <p className="text-xs font-semibold uppercase tracking-wider text-slate-500">Brand</p>
        <div className="mt-3 grid gap-4 sm:grid-cols-3">
          <Field label="Colore principale" hint={ai ? "Vuoto: lo sceglie l'AI" : "Vuoto: resta quello attuale"}>
            <div className="flex gap-2">
              <input type="color" value={/^#[0-9a-f]{6}$/i.test(client.primary_color) ? client.primary_color : "#0f172a"} onChange={set("primary_color")} className="h-9 w-10 rounded border p-0.5" data-testid="dup-color-picker" />
              <Input value={client.primary_color} onChange={set("primary_color")} placeholder="#173F43" className="font-mono" data-testid="dup-primary-color" />
            </div>
          </Field>
          <Field label="Font titoli"><FontPick value={fh} onChange={(v) => setFonts(v, fb)} empty={ai ? "Scelto dall'AI" : "Attuale"} testid="dup-font-heading" /></Field>
          <Field label="Font testo"><FontPick value={fb} onChange={(v) => setFonts(fh || v, v)} empty={ai ? "Scelto dall'AI" : "Attuale"} testid="dup-font-body" /></Field>
        </div>
      </div>
      {ai && <Field label="Note per l'AI"><Textarea rows={2} value={client.notes} onChange={set("notes")} placeholder="Tono di voce, elementi da evidenziare, pagine da aggiungere…" data-testid="dup-notes" /></Field>}
      <ImageOptions mode={mode} images={images} setImages={setImages} models={models} />
    </div>
  );
}
